// Sticky table-of-contents navigation for the event action plan show page.
// Provides smooth-scroll jumping, active-section highlighting, and a mobile
// slide-in drawer. Runs only on pages that contain the show layout.

document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('action_plan_show');
  if (!root) { return; }

  var links = Array.prototype.slice.call(
    document.querySelectorAll('.action-plan-toc__link')
  );
  if (!links.length) { return; }

  var drawer = document.getElementById('action-plan-toc-drawer');
  var fab = document.querySelector('.action-plan-toc-fab');
  var backdrop = document.querySelector('.action-plan-toc-backdrop');
  var closeBtn = document.querySelector('.action-plan-toc-drawer__close');

  // --- Mobile drawer ---------------------------------------------------------
  function openDrawer() {
    if (!drawer) { return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) { backdrop.classList.add('is-open'); }
    if (fab) { fab.setAttribute('aria-expanded', 'true'); }
    document.body.classList.add('toc-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) { backdrop.classList.remove('is-open'); }
    if (fab) { fab.setAttribute('aria-expanded', 'false'); }
    document.body.classList.remove('toc-drawer-open');
  }

  if (fab) { fab.addEventListener('click', openDrawer); }
  if (closeBtn) { closeBtn.addEventListener('click', closeDrawer); }
  if (backdrop) { backdrop.addEventListener('click', closeDrawer); }

  // --- Smooth scroll + close drawer on click ---------------------------------
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) { return; }
      event.preventDefault();
      closeDrawer();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    });
  });

  // --- Active-section highlighting -------------------------------------------
  var sections = links
    .map(function (link) {
      return document.getElementById(link.getAttribute('href').slice(1));
    })
    .filter(Boolean);

  function setActive(id) {
    links.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
    });
  }

  if ('IntersectionObserver' in window && sections.length) {
    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      // Highlight the first section (in document order) currently in view.
      for (var i = 0; i < sections.length; i++) {
        if (visible[sections[i].id]) {
          setActive(sections[i].id);
          break;
        }
      }
    }, { rootMargin: '-10% 0px -70% 0px', threshold: 0 });

    sections.forEach(function (section) { observer.observe(section); });
  }
});
